module.exports = __webpack_public_path__ + "static/media/bottom-sheet.4107d6b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bottom-sheet.png
// module id = 36
// module chunks = 0